export default __webpack_public_path__ + "static/media/icon_neutral.aa10fca3.svg";